module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre11",
    attrs: {
      "id": "pgepubid00009"
    }
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "id": "Chapter_1"
    }
  }, [_vm._v("CHAPTER I.")])]), _vm._v(" "), _c('h4', {
    staticClass: "calibre8 sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00010"
    }
  }, [_vm._v("A WELSH HOTEL.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“COME, Dulcie! Dulcie, my dear! Not ready yet?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("A spice of good-humored impatience breathed through the rich bass\ntones. George Rutherford stood in the hall of a somewhat primitive\nWelsh hotel. The door opening into a sitting-room, on one side,\ndisplayed sundry ladies and gentlemen, occupied or non-occupied in\nvarious ways. The door opening into the kitchen, on the other side,\ndisplayed a waiter or two in shirtsleeves, coming and going. The front\ndoor, opening on the hotel grounds, displayed a bare, gravelly space,\nwith shrubs around, a short avenue of trees beyond, and glimpses of\ndistant hills softly outlined against a blue sky.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Mr. Rutherford was a man of perhaps five or six-and-thirty years,\nunusually tall and massive in make, yet not stout. Honest brown eyes\nlooked out from beneath a brow of remarkable breadth, which was framed\nin an abundant growth of tawny hair, fine as silk in texture. Moustache\nand beard, of a somewhat darker hue than the hair upon his head, almost\nhid a mouth of characteristic and beautiful outlines. He stood at the\nfoot of the staircase, grasping a huge, crook-handled walking stick as\ntall as himself; and blissfully unconscious of, or indifferent to, the\nattention he was attracting from the inmates of the drawing-room, while\nhe called again, in tones “not loud, but deep” —")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Dulcie, my dear, make haste!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“That’s the bridegroom,” murmured a mild-faced maiden lady, quite an\nold resident at the hotel, since she had been there a fortnight. She\naddressed herself to a “new arrival,” seated by her side. “We call them\n‘our bride and bridegroom.’ They came two days ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Why, he might be the father of half-a-dozen children,” quoth the\nnewly arrived, a stout and genial widow, well on in middle life. “He a\nbridegroom!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“I don’t know whether there has been a former marriage, but I rather\nimagine not. Oh, it is evidently a wedding tour!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("A boy of about ten came bounding downstairs in light leaps, clearing\nfour or five steps at a time. He too had brown eyes, and a mass of\ntawny hair falling over a fine brow.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“She’s coming, uncle.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Would do for his son,” murmured the widow.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Georgie dear,” called a small and eager voice from the landing above,\n“I’ll be down directly—in one moment. There’s a button off my boot, and\nI must sew it on.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“All right,” responded Mr. Rutherford. “We’ll wait in front. Come,\nLeo!” and he strode out.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“He doesn’t look much like a ‘Georgie,’” softly said the new-comer to\nthe maiden lady. “What a nice boy! But I don’t understand his presence\nif it is a wedding tour.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“I don’t know that any one exactly understands. I fancy Mr. Rutherford\nis a man likely to do things in a fashion unlike everybody else.\nPerhaps he has adopted the boy. Here comes the bride.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The lady, running swiftly downstairs, could hardly have been less than\nsix or seven-and-twenty in age. She was as small and slim in make as\nher husband was tall and massive, and so fair in coloring that his\ntawny beard might almost be counted dark beside her smooth flaxen hair.\nThe pale fringes to her blue eyes were unwontedly long and thick, and\nthere was enough coloring in her cheeks to obviate insipidity. Her\nmanner was marked by an eagerness amounting to flurry; and as she ran\nout of the front door she grasped a long stick, a rolled-up waterproof,\na closed basket, a book, and a pair of gloves.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Georgie, dear, I’m so sorry,” she was heard to say.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“All right,” responded Mr. Rutherford once more. “Hadn’t you better\ngive me some of your paraphernalia?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Oh, yes—oh, thank you, dear! It’s only this book—Trench’s Poems, you\nknow. You said you would read me some of it. Will it go into your\npocket? And Leo said I must be sure to take my stick. And I thought\nwe might want my cloak to sit on, if the grass should be damp. And in\ncase of being late for lunch, it is best to have some biscuits and a\nsandwich or two, because then we shall not feel so hurried.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Anything else?” asked George, with an expressive intonation.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Mrs. Rutherford looked up, her anxious little fair face breaking into a\nsmile.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Now you are laughing at me, Georgie, dear.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Not at all. Always best to be prepared for emergencies. Well, come\nalong, both of you. We shall not be back, at this rate, till—”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Midnight,” suggested Leonard.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“No; dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Lunch won’t matter, now we have something with us,” said Dulcibel,\nbeginning to subside from her flurry. “You are going to show me your\nfavorite valley, are you not, dear? Oh, don’t! I can easily carry the\nbasket, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Give it to me. Here, Dulcie—I mean what I say. Leo will take your\nwaterproof. If you can carry yourself there and back it will be as much\nas you are equal to.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“I am sure I can. I feel equal to anything to-day.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Equal to anything” meant, as her husband knew by experience, equal\nto four or five miles, the latter part performed distressfully.\nTwenty or thirty miles were nothing to him. In her own home, before\nmarriage, Dulcibel Lloyd had counted two miles an arduous undertaking,\nbut George Rutherford was getting her slowly into training. They had\nbeen married just seven months, so it was not precisely a case of the\nhoneymoon. In one sense they might be said to be still on their wedding\ntrip, however. Dulcie had not yet seen her husband’s home, extensive\nalterations in it making a prolonged absence necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("They were by no means in one of the more mountainous parts of Wales.\nThe hotel stood outside a small village, on the verge of a wild moor;\nthe name of the village containing the liquid double “l,” as did\nthe names of many villages near. Undulating hills lay around in all\ndirections, showing autumn tints; and two or three mountains, attaining\nthe respectable height of two thousand feet or more, were visible at a\nlittle distance.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("George Rutherford had been to the spot a few years earlier, and he\nretained warm recollections of his visit. He was anxious now to display\nthe charms of the place to his wife and nephew.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The walk to his favorite valley was fair enough, and the valley proved\nto be fairer still. Dulcibel would not attempt to learn the name, which\nhad a softly indefinite sound like running water, perplexing to Saxon\nears.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“I want to see what you like, but I don’t care what it is called,”\nshe protested. “It will always be ‘Georgie’s Valley’ to me. I dislike\nhaving to talk consonants; and what is the use?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("George laughed, and gave in.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The valley lay level and green, with rounded well-clothed hills\nsurrounding, and a wide stream or small river partly skirting it. The\nstream had to be crossed by a “shaking bridge” of local celebrity, a\nsomewhat narrow structure of planks bound strongly together with wire,\nthe whole depending on chains, and showing a singular elasticity, for\nit vibrated and swung at every step.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Dulcibel shrank back at first, absolutely refusing to cross or to\nlet her companions cross. It was “dangerous,” she said; something\nwould give way, or somebody would be giddy and tumble in. But George\nmercilessly strode to the centre and stood there, keeping the bridge in\nmotion, with evident enjoyment of its undulations, and Leonard dashed\nmerrily over. Dulcibel was fain to summon up her courage, and consent\nto be led across by her husband’s strong hand, growing absolutely white\nwith fear.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“I shall enjoy nothing with the thought of having to go back,” she\naverred, tremulously, on the other side.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("George looked down on her with a strong, tender pity, and said softly—")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“O thou of little faith!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Georgie, dear, I’m very wrong—I’m always frightened at something,” she\nsaid, apologetically; “but you know it is my way.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“You don’t really think I would bring my little wife where there was\ndanger?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Oh, no! O Georgie, dear, no! It’s only that I am silly,” she said, her\nthick fair lashes downcast and wet.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Well, don’t be silly any more. There are troubles enough in life,\nwithout manufacturing them out of nothing. See, isn’t this pretty?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("A very old gray church stood in the centre of the level green valley;\nand this of course had to be entered and examined, the key having been\nprocured at a cottage on the way thither. The whitewashed walls and\ndusty floor within roused George’s displeasure; and Dulcibel cried out\nagainst the great roof-beams as “ugly,” till she found that he counted\nthem worthy of admiration, whereupon she quieted into brief silence.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("They found their way then to the river edge, near the church;\nand Dulcibel would be content with nothing short of an immediate\npreliminary luncheon.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Not the sandwiches yet,” she said; “but biscuits. Now don’t say you\nare not hungry, Georgie dear; for I know you are. I’m almost starving.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("George disposed of a biscuit obediently, and then found himself called\nupon to read poetry aloud. Not that Dulcibel possessed any ear or soul\nfor poetry; but she knew George loved it, and she was a most dutiful\nwife. George thoroughly appreciated her wish to please him, though no\ndoubt he would have appreciated still more heartily the discovery of\na kindred taste in her. But this was not to be expected; so he only\nsmiled under his tawny moustache, and asked—")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“What shall I read?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Oh, something short and pretty, dear! Trench’s poems have such nice\nstories in them sometimes.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The tawny moustache twitched again.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Now don’t, Georgie, dear! You know I shall like whatever you choose.\nWhat have you opened upon now?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“These are only couplets—favorites of mine, rather. How do you like\nthis, Dulcie?—")]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre13"
  }, [_vm._v("“Things earthly we must know ere love them; ’tis alone")])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre14"
  }, [_vm._v("Things heavenly that must be first loved and after known.”")])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre13"
  }, [_vm._v("“To see the face of God, this makes the joy of heaven;")])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre14"
  }, [_vm._v("The purer then the eye, the more joy will be given.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    staticClass: "calibre15"
  }, [_vm._v("*        *        *        *        *        *")])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre13"
  }, [_vm._v("“When God afflicts thee, think he hews a rugged stone,")])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre14"
  }, [_vm._v("Which must be shaped or else aside as useless thrown.”")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“I don’t like that,” said Dulcibel. “Why, Georgie, it sounds as if one\nought to wish for trouble.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“No; only to recognize the good of trouble when it comes.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“But I can’t. And I dislike the thought of its coming—of anything ever\nchanging. I’m so perfectly happy now, I should like to go on and go\non always—just like this. But I know I can’t. I suppose one has to\nbe ‘shaped’; but it seems to me very dreadful. I can’t bear to look\nforward sometimes, and to fancy all the things that may happen in life.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Fearing again, Dulcie?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“How can I help it? I love you so; and changes must come. And I dread\nchanges.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Her hand was on George’s knee, and the words came with almost sobs\nbetween. Once more George said softly—")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“‘O thou of little faith,’ Dulcie!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“I think I must have little faith—very, very little. Looking forward\nmakes me so afraid. I can’t bear the thought of anything passing\naway—as things are now. I never was so happy in all my life before.\nGeorgie—was it very foolish of me?—last night I was lying awake,\ncrying, thinking what it would be if you were to be taken. Life\nwouldn’t be worth living then. It wouldn’t, dear;” and there came a\ndownright sob.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The boy Leo was away at some distance. George’s eyes fell again on the\nopen page of the book; and he read aloud, in answer—")]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre13"
  }, [_vm._v("“Ill fares the child of Heaven who will not entertain")])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre14"
  }, [_vm._v("On earth the stranger’s grief, the exile’s sense of pain.”")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“But I don’t,” said Dulcibel. “Of course one speaks of heaven as one’s\nhome; and I suppose it ought to seem so. But I don’t feel the least\nlike an exile on earth. And the pain is in expecting things to change,\nknowing death must come; not in being away from heaven now.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Dulcie, I would leave off expecting and fearing,” said her husband.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“I can’t. It is my way.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("George turned a few pages, and read aloud once more, in his strong deep\nvoice:—")]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre13"
  }, [_vm._v("“I say to thee—do thou repeat")])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre14"
  }, [_vm._v("To the first man thou mayest meet,")])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre14"
  }, [_vm._v("In lane, highway, or open street—”")])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre13"
  }, [_vm._v("“That he and we and all men move")])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre14"
  }, [_vm._v("Under a canopy of love,")])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre14"
  }, [_vm._v("As broad as the blue sky above;”")])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre13"
  }, [_vm._v("“That doubt and trouble, fear and pain")])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre14"
  }, [_vm._v("And anguish, all are shadows vain,")])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre14"
  }, [_vm._v("That death itself shall not remain;”")])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre13"
  }, [_vm._v("“That weary deserts we may tread,")])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre14"
  }, [_vm._v("A dreary labyrinth may thread,")])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre14"
  }, [_vm._v("Through dark ways underground be led.”")])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre13"
  }, [_vm._v("“Yet if we will one Guide obey,")])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre14"
  }, [_vm._v("The dreariest path, the darkest way,")])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre14"
  }, [_vm._v("Shall issue out in heavenly day.”")])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre13"
  }, [_vm._v("“And we, on divers shores now cast,")])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre14"
  }, [_vm._v("Shall meet, our perilous voyage past,")])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', {
    staticClass: "calibre14"
  }, [_vm._v("All in our Father’s House at last.”")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Dulcibel’s hand came over the page.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“George, you are making me dreadfully melancholy. I don’t think I can\nhear any more. I shall have to cry outright. I’m quite sure the last\nverse means something about being parted, and I can’t bear to think of\nparting. Please stop! I’m going to dip my hands in the water: and you\ncan read a little more to yourself if you like. I wonder if there are\nany fish in the river.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ff7c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 66
// module chunks = 0